export default __webpack_public_path__ + "static/media/GN.7fad0727.svg";